import React, { useContext, useState, useEffect } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { useHistory } from 'react-router-dom';
import withSizes from 'react-sizes';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import SearchBar from 'components/SearchBar';
import { Typography, ButtonBase, Grid } from '@material-ui/core';
import useContentfulLocale from 'components/useContentfulLocale';
import PageContext from '../PageContext';

const useStyles = makeStyles(theme => ({
  searchWrapper: {
    '& > div': {
      height: 53,
      border: 'none',
      [theme.breakpoints.down('xs')]: {
        height: 48,
      },
      '& > div': {
        width: 70,
        borderRadius: 0,
        '& > button': {
          width: '100%',
          height: '100%',
          borderRadius: 0,
        },
      },
      '& > svg': {
        right: 75,
      },
    },
    '& input': {
      height: 53,
      border: 'none',
      [theme.breakpoints.down('xs')]: {
        height: 48,
      },
    },
  },
  searchTerms: {
    display: 'flex',
    alignItems: 'center',
    color: props => props.introColor || '#fff',
    fontSize: 16,
    lineHeight: '22px',
    flexWrap: 'wrap',
  },
  searchLabel: {
    marginRight: 6,
    fontSize: 16,
    lineHeight: '22px',
    fontFamily: 'MadaRegular',
  },
  searchTerm: {
    textDecoration: 'underline',
    marginRight: 5,
    fontSize: 16,
    lineHeight: '22px',
    fontFamily: 'MadaRegular',
  },
}));

function Search({ isMobile, otherLanguage }) {
  const { clientInfo, textColor } = useContext(PageContext);
  const [showSearchTerm, setShowSearchTerm] = useState(true);

  const { pageText, fontColor, locale } = otherLanguage
    ? clientInfo[1] || clientInfo[0]
    : clientInfo[0];
  const introColor = _get(pageText, 'hero.introColor') || fontColor;
  const history = useHistory();
  const classes = useStyles({
    introColor: introColor ? `#${introColor}` : textColor,
  });
  const ctfLocaleFilter = useContentfulLocale();
  const searchTerms = _get(
    otherLanguage ? clientInfo[1] || clientInfo[0] : clientInfo[0],
    'pageText.search.values',
    [],
  );
  const hasTopSearch = !_isEmpty(searchTerms);
  const redirect = value =>
    history.push(
      `/resources?query=${value}?lang=${locale || ctfLocaleFilter.locale}`,
    );

  useEffect(() => {
    if (!isMobile) {
      setShowSearchTerm(true);
    }
  }, [isMobile]);

  const clickHandler = focus => {
    if (isMobile) {
      setShowSearchTerm(!focus);
    }
  };
  return (
    <Grid item xs={12} className={classes.searchWrapper}>
      <SearchBar
        isVariantE
        callback={clickHandler}
        variantELocale={locale || ctfLocaleFilter.locale}
        otherLanguage={otherLanguage}
      />
      {hasTopSearch && showSearchTerm && (
        <div className={classes.searchTerms}>
          <Typography className={classes.searchLabel}>
            {_get(
              otherLanguage ? clientInfo[1] || clientInfo[0] : clientInfo[0],
              'pageText.search.label',
            )}
            :
          </Typography>
          {searchTerms.map((value, index) => (
            <ButtonBase
              className={classes.searchTerm}
              disableRipple
              onClick={() => redirect(value)}
            >
              {value}
              {index < searchTerms.length - 1 ? ', ' : ''}
            </ButtonBase>
          ))}
        </div>
      )}
    </Grid>
  );
}

Search.propTypes = {
  isMobile: PropTypes.bool,
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width <= 600,
});

export default withSizes(mapSizesToProps)(Search);
